import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProfileIcon from "../../assets/settings/profile-icon.svg";
import ManagementIcon from "../../assets/settings/management-icon.svg";
import BillingIcon from "../../assets/settings/billing-icon.svg";
import SecurityIcon from "../../assets/settings/security-icon.svg";
import CancellationIcon from "../../assets/settings/cancellation-icon.svg";
import { useTranslation } from "react-i18next";
import PathHelper from "../../utils/path-helper";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";

const Sidebar = ({
  open,
  setOpen,
  isHide,
  isNormalUser,
  isGuestUser,
  isPremiumOrGuest,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const settingsPath = PathHelper(APP_NAVIGATION.SETTINGS, currentLocale);

  const scrollToCenter = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - window.innerHeight / 4;
      window.scrollTo({
        top: middle,
        behavior: "smooth",
      });
    }
  };

  const handleNavigation = (route, label) => {
    navigate(route);
    setOpen(false);
    setTimeout(() => {
      scrollToCenter(label.toLowerCase().replace(" ", "-"));
    }, 100); // Small delay to ensure the new page has loaded
  };

  const tabs = [
    {
      label: `${t("settings.profile")}`,
      route: `${settingsPath.next}?steps=profile`,
      show: true,
      icon: ProfileIcon,
    },
    {
      label: `${t("settings.user_management")}`,
      route: `${settingsPath.next}?steps=user_management`,
      show: !isGuestUser,
      icon: ManagementIcon,
    },
    {
      label: `${t("settings.billing")}`,
      route: `${settingsPath.next}?steps=billing`,
      show: !isGuestUser,
      icon: BillingIcon,
    },
    {
      label: `${t("settings.security")}`,
      route: `${settingsPath.next}?steps=security`,
      show: isNormalUser,
      icon: SecurityIcon,
    },
    {
      label: `${t("settings.cancellation")}`,
      route: `${settingsPath.next}?steps=cancellation`,
      show: !isGuestUser && !isHide && isPremiumOrGuest,
      icon: CancellationIcon,
    },
  ];

  return (
    <>
      {open && (
        <div className="flex items-center max-w-full shadow-2xl lg:shadow-lg shadow-insightful-gray lg:shadow-insightful-lightest-gray rounded-lg">
          <nav className="md:w-full mb-8 md:mb-0 md:block rounded-lg">
            <ul className="max-w-full space-y-2 bg-white rounded-lg shadow-md p-4">
              {tabs.map(
                (tab, index) =>
                  tab.show && (
                    <li
                      key={index}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavigation(tab.route, tab.label);
                      }}
                    >
                      <a
                        href={`#${tab.label.toLowerCase().replace(" ", "-")}`}
                        className="block px-4 py-2 rounded-md transition duration-300 ease-in-out text-insightful-black hover:bg-insightful-lightest-purple hover:text-indigo-600"
                      >
                        <div className="flex items-center gap-3">
                          <img src={tab.icon} alt="" />
                          {tab.label}
                        </div>
                      </a>
                    </li>
                  )
              )}
            </ul>
          </nav>
        </div>
      )}
    </>
  );
};

export default Sidebar;
